export default __webpack_public_path__ + "static/media/responsive2.e9af5a7a.png";